module.exports = "<div id=\"map\" class=\"{{class}}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/google-map/google-map.component.html
// module id = 1032
// module chunks = 22